import React from 'react'
import injectSheet from 'react-jss'
import styles from './sidebar-item.styles'
import classNames from 'classnames'

const SidebarItem = ({
  classes,
  icon,
  children,
  active,
  showLabel,
  onClick,
  disabled
}) => (
  <div
    onClick={!disabled ? onClick : null}
    className={classNames(classes.container, {
      [classes.active]: active,
      [classes.showLabel]: showLabel,
      [classes.disabled]: disabled
    })}>
    <span className={classes.iconHolder}>{icon}</span>
    {children && <span className={classes.label}>{children}</span>}
  </div>
)

export default injectSheet(styles)(SidebarItem)
